<div class="login-body text-dark">
  <div class="login-wrapper">
    <div class="login-panel">
      <a [routerLink]="['/']" class="logo">
        <img
          src="assets/classjax-logo-dark.svg"
          alt="ClassJax Logo"
          class="img-fluid"
          style="width: 150px"
        />
      </a>

      <h2>Reset your password</h2>

      @if (sent()) {
        <div class="login-form">
          <div class="alert alert-success" role="alert">
            If an account exists for that email, a password-reset link is on its way.
            Check your inbox.
          </div>
          <p class="mt-4">
            <a routerLink="/signin">Back to sign in</a>
          </p>
        </div>
      } @else {
        <form
          class="login-form"
          [formGroup]="form"
          (ngSubmit)="submit()"
          novalidate
          autocomplete="off"
        >
          <p class="text-muted">
            Enter your email and we'll send you a link to reset your password.
          </p>

          @if (error(); as err) {
            <div class="alert alert-danger" role="alert">{{ err }}</div>
          }

          <div class="form-floating">
            <input
              type="email"
              class="form-control form-control-only"
              id="emailField"
              placeholder="name@example.com"
              autocomplete="off"
              formControlName="email"
            />
            <label for="emailField" class="text-dark">Email</label>
          </div>

          @if (captchaEnabled) {
            <div class="my-2">
              <app-turnstile formControlName="captchaToken"></app-turnstile>
            </div>
          }

          <button
            type="submit"
            class="w-100 btn btn-lg btn-primary text-white"
            [class.fk-busy]="busy()"
            [disabled]="form.invalid || busy()"
          >
            SEND RESET LINK
          </button>

          <p class="mt-4">
            <a routerLink="/signin">Back to sign in</a>
          </p>
        </form>
      }
    </div>
  </div>
</div>
